module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/161-ivory-coast-d311bc41bdff1c2aaba446c923dca8b0.svg";